import React from "react";
import { useParams } from "react-router";

import useFirebaseKilns from "../hooks/useFirebaseKilns";
import useFirebaseProject from "../hooks/useFirebaseProject";
import ProjectForm from "./ProjectForm";
import useProjectActions from "../hooks/useProjectActions";

const ProjectEditPage = () => {
  const { editProject } = useProjectActions();
  const kilns = useFirebaseKilns();
  const { id } = useParams();

  const project = useFirebaseProject(id!);

  //const kiln_array = Object.values(kilns);
  if (!kilns) {
    return <div>Please create a kiln first</div>;
  }
  if (!project) {
    return <div>Loading...</div>;
  }
  const handleSubmit = (formValues: any) => {
    editProject(id!, {
      ...project,
      photos: project.photos || [],
      ...formValues,
    });
  };
  const initialValues = {
    name: "",
    width: "",
    depth: "",
    glass: "Bullseye",
    thickness: "6",
    stars: 2.5,
    notes: "",
    length_unit: "mm",
    tags: [],
    sale_status: "",
    material_cost: "",
    firing_cost: "",
    labour_cost: "",
    sale_price: "",
    sold_to: "",

    ...project,
  };
  return (
    <div>
      <ProjectForm onSubmit={handleSubmit} initialValues={initialValues} />
    </div>
  );
};

export default ProjectEditPage;
